import { render } from "./ProjectPriceStep.vue?vue&type=template&id=372477dd"
import script from "./ProjectPriceStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectPriceStep.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/ProjectPriceStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "372477dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('372477dd', __exports__)) {
    api.reload('372477dd', __exports__)
  }
  
  module.hot.accept("./ProjectPriceStep.vue?vue&type=template&id=372477dd", () => {
    api.rerender('372477dd', render)
  })

}


export default __exports__